<template>
  <div class="tag-body">
    <div class="tag-views scrollbar">
      <!-- <div
        v-for="item in viewTagList"
        :key="item.path"
        class="tag-list"
      > -->
      <!--   :class="{ 'is-active': item.path == $route.path }" -->
      <p
        v-for="item in viewTagList"
        :key="item.path"
        class="tag"
        :class="{ 'is-active': item.path == $route.path }"
        @click="goTagRouter(item)"
      >
        <span class="title">{{ item.title }}</span>
        <svg-icon
          @click.stop="closeTag(item)"
          v-if="viewTagList.length > 1 && !item.isDefault"
          icon-class="icon_tag_close"
        ></svg-icon>
      </p>
      <!-- </div> -->
    </div>
    <!-- <el-popover
      placement="bottom-end"
      width="278"
      trigger="hover"
      popper-class="tag-view-popover"
      :visible-arrow="false"
    >
      <span class="drop_down" slot="reference">
        <svg-icon icon-class="down_full_color"></svg-icon>
      </span>
      <div class="drop-info">
        <p
          class="drop-tag"
          @click="closeTag($route)"
          v-if="viewTagList.length > 1"
        >
          关闭当前页签
        </p>
        <p
          class="drop-tag"
          @click="closeOtherTag()"
          v-if="viewTagList.length > 1"
        >
          关闭所有其他页签
        </p>
        <el-divider v-if="viewTagList.length > 1"></el-divider>
        <p
          class="drop-tag"
          v-for="item in viewTagList"
          @click.stop="closeTag(item)"
          :key="item.path"
          :class="{ 'is-active': item.path == $route.path }"
        >
          <span class="title">{{ item.title }}</span>
          <svg-icon
            @click.stop="closeTag(item)"
            v-if="viewTagList.length > 1"
            :icon-class="
              item.path == $route.path ? 'icon_tag_close' : 'icon_close_no_bag'
            "
          ></svg-icon>
        </p>
      </div>
    </el-popover> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SvgIcon from "../SvgIcon.vue";
export default {
  name: "TabViews",
  components: {
    SvgIcon,
  },
  props: {
    defaultTags: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["viewTagList"]),
  },
  watch: {
    $route(to, from) {
      this.addTag();
    },
    defaultTags: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.length) {
          val.forEach((el) => {
            this.$store.dispatch("addViewTag", el);
          });
        }
      },
    },
  },

  created() {},
  mounted() {
    this.$nextTick(() => {
      // this.getTagViewNum();
      this.addTag();
    });
  },
  methods: {
    getTagViewNum() {
      let fullDom = document.getElementsByClassName("tag-views");
      let fullWidth =
        fullDom && fullDom.length > 0 ? fullDom[0].clientWidth : null;
      let fullNum = 0;
      if (fullWidth) {
        fullNum = Math.floor(fullWidth / 142);
      }
      this.$store.dispatch("setMaxTagNum", fullNum);
    },
    addTag() {
      if (!this.$route.meta || !this.$route.meta.noTagView) {
        let routeParams = {
          fullPath: this.$route.fullPath,
          path: this.$route.path,
          title: this.$route.meta.title || "暂无标题",
        };
        this.$store.dispatch("addViewTag", routeParams);
      }
    },
    /**页签跳转 */
    goTagRouter(item) {
      this.$router.push({
        path: item.fullPath,
      });
    },
    /**关闭页签 */
    closeTag(item) {
      let index = this.viewTagList.findIndex((el) => {
        return el.path === item.path;
      });
      if (item.path == this.$route.path) {
        let routePath = "";
        if (index == 0) {
          routePath = this.viewTagList[index + 1].fullPath;
        } else {
          routePath = this.viewTagList[index - 1].fullPath;
        }
        this.$router.replace({
          path: routePath,
        });
      }
      this.$store.dispatch("delViewTag", item);
    },
    /**关闭所有其他标签 */
    closeOtherTag() {
      this.$store.dispatch("delOtherViewTag", this.$route);
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-body {
  display: flex;
  justify-content: space-between;
  background: #fff;
  align-items: center;
  padding: 0 16px;
}
.tag-views {
  flex: 1;
  display: flex;
  align-items: center;
  // overflow: hidden;
  overflow-x: auto;
  height: 47.5px;

  .tag {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    color: #7988a4;
    font-size: 14px;
    cursor: pointer;
    position: relative;
    border: 1px solid #dbe1ed;
    border-radius: 6px;
    margin-right: 8px;
    &:hover {
      border: 1px solid $primaryColor;
      color: $primaryColor;
    }
    &.is-active {
      font-family: PingFangSC-Medium;
      background: #005bac;
      border: 1px solid transparent;
      border-radius: 6px;
      font-weight: 500;
      color: #fff;
      .title {
        font-family: PingFangSC-Medium;
      }
    }
    .title {
    }
    .svg-icon {
      margin-left: 8px;
      font-size: 12px;
    }
  }
}
.drop-info {
  padding: 8px 0;
  .el-divider {
    margin: 10px 0;
  }
}

.drop-tag {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #15212d;
  letter-spacing: 0;
  line-height: 16px;
  font-weight: 500;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:not(:last-child) {
    margin-bottom: 4px;
  }
  &:hover {
    &:not(.is-active) {
      background: #eff4f9;
      .svg-icon {
        opacity: 1;
      }
    }
  }
  &.is-active {
    background: #d4e2f0;
    .svg-icon {
      opacity: 1;
    }
  }
  .title {
    flex: 1;
    margin-right: 17px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .svg-icon {
    opacity: 0;
  }
}
</style>
<style lang="scss">
.tag-view-popover {
  padding: 0 !important;
}
</style>
